import { h as __h } from "preact";
/** @import { ComponentChildren } from "preact"; */
import html from "~/util/html.js";
import DisabledTooltip from "~/admin/component/DisabledTooltip.js";

/**
 * Explains a membership control disabled because SCIM mappings are on. The control must disable
 * itself too.
 *
 * @param {object} props
 * @param {boolean} props.locked
 * @param {ComponentChildren} [props.children]
 */
export default function MappingsLock({
  locked,
  children
}) {
  return __h(DisabledTooltip, {
    tooltip: locked && "Managed by directory mappings"
  }, children);
}